import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { stepInfoAboutDamageUpdate } from '../../../actions/damageReportActions';
import { ReactComponent as IconBoxFalling } from '../../../icons/box-falling.svg';
import { ReactComponent as IconCheckMark } from '../../../icons/checkmark-in-circle.svg';
import { ReactComponent as IconParcel } from '../../../icons/parcel.svg';
import { Columns } from '../../base/grid';
import { A, H5, P } from '../../base/typography';
import * as StyledDamageReportOptions from './damageReportOptions.styles';

interface Props {
	selectOption: any;
}

const DamageReportOptions: FC<Props> = ({ selectOption }) => {
	const { t } = useTranslation('damageReport');
	const dispatch = useDispatch<any>();
	const onOptionSelect = val => {
		dispatch(stepInfoAboutDamageUpdate(val));
		selectOption(val);
	};

	return (
		<Columns>
			<StyledDamageReportOptions.StyledColumn desktopSmall={1 / 3}>
				<StyledDamageReportOptions.OptionWrapper onClick={() => onOptionSelect('reportDamage')}>
					<StyledDamageReportOptions.ContentWrapper>
						<IconBoxFalling />
						<H5 marginTop="2rem" marginBottom="2rem">
							{t('report-damage')}
						</H5>
						<P>{t('report-damage-text')}</P>
					</StyledDamageReportOptions.ContentWrapper>
					<A onClick={() => onOptionSelect('reportDamage')}>{t('report')}</A>
				</StyledDamageReportOptions.OptionWrapper>
			</StyledDamageReportOptions.StyledColumn>
			<StyledDamageReportOptions.StyledColumn desktopSmall={1 / 3}>
				<StyledDamageReportOptions.OptionWrapper onClick={() => onOptionSelect('shipmentMissing')}>
					<StyledDamageReportOptions.ContentWrapper>
						<IconParcel />
						<H5 marginTop="2rem" marginBottom="2rem">
							{t('shipment-missing')}
						</H5>
						<P>{t('shipment-missing-text')}</P>
					</StyledDamageReportOptions.ContentWrapper>
					<A onClick={() => onOptionSelect('shipmentMissing')}>{t('report')}</A>
				</StyledDamageReportOptions.OptionWrapper>
			</StyledDamageReportOptions.StyledColumn>
			<StyledDamageReportOptions.StyledColumn desktopSmall={1 / 3}>
				<StyledDamageReportOptions.OptionWrapper onClick={() => onOptionSelect('itemMissing')}>
					<StyledDamageReportOptions.ContentWrapper>
						<IconCheckMark />
						<H5 marginTop="2rem" marginBottom="2rem">
							{t('item-missing')}
						</H5>
						<P>{t('item-missing-text')}</P>
					</StyledDamageReportOptions.ContentWrapper>
					<A onClick={() => onOptionSelect('itemMissing')}>{t('report')}</A>
				</StyledDamageReportOptions.OptionWrapper>
			</StyledDamageReportOptions.StyledColumn>
			<StyledDamageReportOptions.StyledColumn desktopSmall={3 / 3}>
				<StyledDamageReportOptions.InfoWrapper>
					<ul>
						<li>{t('info-text.1')}</li>
						<li>{t('info-text.2')}</li>
						<li>{t('info-text.3')}</li>
						<li>{t('info-text.4')}</li>
					</ul>
				</StyledDamageReportOptions.InfoWrapper>
			</StyledDamageReportOptions.StyledColumn>
		</Columns>
	);
};

export default DamageReportOptions;
